<template>
    <div>
        <div class="banner equipment-bn">
            <img src="@/assets/images/banner4.png" alt="">
            <h2 class="title">Equipment｜開啟美好</h2>
        </div>
        <div class="wrap">
            <section id="tabs-block" class="section">
                <ul class="text-center">
                    <li v-for="equipment_list in equipment_lists" :key="equipment_list.id">
                        <a :href="'#a_'+ equipment_list.id" class="tabs-item tabsGo">
                            <div class="name name_style">
                                <div>
                                    {{ equipment_list.title }}
                                </div>
                            </div>
                            <!-- <div class="name">茶水<br>間</div> -->
                            <!-- <p>Pantry</p> -->
                        </a>
                    </li>
                </ul>
            </section>
            <section v-for="equipment in equipment_lists" :key="equipment.id" :id="'a_'+ equipment.id" class="section equipment-block">
                <div class="intro">
                    <div class="name text-center">
                        {{ equipment.title }}
                    </div>
                    <div class="text">
                        {{ equipment.content }}
                    </div>
                </div>
                <div class="gallery-block">
                    <!-- <div class="box box-lg" :style="{backgroundImage: 'url(' + require('@/assets/images/pic1.png') + ')' }"></div>
                    <div class="box box-sm" :style="{backgroundImage: 'url(' + require('@/assets/images/pic1-4.png') + ')' }"></div>
                    <div class="box box-sm" :style="{backgroundImage: 'url(' + require('@/assets/images/pic1-3.png') + ')' }"></div>
                    <div class="box box-sm" :style="{backgroundImage: 'url(' + require('@/assets/images/pic1-2.png') + ')' }"></div>
                    <div class="box box-sm" :style="{backgroundImage: 'url(' + require('@/assets/images/pic1-1.png') + ')' }"></div> -->
                    <div v-for="(img, idx) in JSON.parse(equipment.images_url)" :key="idx" :class="idx == 0 ? 'box-lg' : 'box-sm'" class="box" :style="{backgroundImage: 'url(' + img + ')' }"></div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>

export default {
    name: 'equipment',
    data () {
        return {
            equipment_lists: []
        }
    },
    beforeMount: function () {
        const formData = new FormData();
        formData.append('CMD', 'EquipmentList');
        formData.append('type', 'all');
        this.$axios.post(process.env.VUE_APP_FROENT_API_PREFIX, formData)
        .then(response => {
            // console.log(response);
            if (response.data.result == false) {
                console.log('EquipmentList: Server Error');
            } else {
                const get_lists = response.data.equipment_list;
                this.equipment_lists = get_lists;
            }
        })
        .catch(error => {
            console.log(error);
        })
    },
    mounted: function() {
        // $(".tabsGo").on("click", function (e) {
        //     e.preventDefault();
        //     var $tabsId = $($(this).attr("href"));
        //     $("html, body").animate({ scrollTop: $tabsId.offset().top - $("#header").height() }, 500);
        // });
        // var filter = $this.data("filter");
        // var $block = $(".filter-block");
        // $this.parent("li").siblings("li").find(".tabs-item").removeClass("active");
        // $this.addClass("active");
        // if (filter === 'All') {
        //     $block.find("[data-category]").fadeIn();
        // } else {
        //     $block.find("[data-category]").each(function () {
        //         if ($(this).data("category") === filter) {
        //             $(this).fadeIn();
        //         } else {
        //             $(this).fadeOut();
        //         }
        //     });
        // }
    }
};
</script>

<style>
.name_style {
    padding: 0px !important;
    display: flex;
    justify-content: center;
    align-items: center;
}
</style>
